import React from "react";
import "./prog_banner.css";
import { getStaticUrl } from "../../../../utils/getStaticUrl";
import { useNavigate } from "react-router-dom";

function ProgBanner() {
  const navigate = useNavigate();

  return (
    <div>
      <img
        src={getStaticUrl("banner/bannermujeres.png")}
        alt="Program Banner"
        loading="eager"
      />
      <div className="prog_ban_text">
        <p>Conoce nuestro trabajo</p>
        <span className="ver-mas-link" onClick={() => navigate("/programas")}>
          Ver más
        </span>
      </div>
    </div>
  );
}

export default ProgBanner;
